import {
  PATH_NAME_CONSTRUCTION, PATH_NAME_EVENT_EMERGENCY, PATH_NAME_HOME, PATH_NAME_PLAYER_TEST,
  PATH_NAME_POPUP_VOUCHER, PATH_NAME_SIGNUP_REDIRECT,
  PATH_NAME_T_LOGIN_CALLBACK, PATH_NAME_WAITING_SERVICE,
  PATH_NAME_WAVVEON_INTRO, PATH_NAME_WAVVIE_POPUP
} from '@/common/resources/router.const'
import { autoLoginProc } from '@/common/utils/login'
import _ from 'lodash'
import cookie from '@/common/utils/cookie'

export default [
  {
    path: '/wavveon',
    name: PATH_NAME_WAVVEON_INTRO,
    alias: '/wavveon.html',
    components: {
      wavveon: () => import('@/pages/wavveon')
    }
  },
  {
    path: '/voucher/popup',
    name: PATH_NAME_POPUP_VOUCHER,
    alias: '/voucher/popup.html',
    components: {
      voucher_popup: () => import(/* webpackChunkName: "popup_voucher" */'@/pages/voucher/popup')
    }
  },
  {
    path: '/tlogincallback.html',
    name: PATH_NAME_T_LOGIN_CALLBACK,
    components: {
      callback: () => import(/* webpackChunkName: "tcallback" */'@/pages/callback/TloginCallback')
    }
  },
  {
    path: '/under_construction',
    name: PATH_NAME_CONSTRUCTION,
    components: {
      construction: () => import(/* webpackChunkName: "under_construction" */'@/pages/under_construction')
    }
  },
  {
    path: '/waiting/service',
    name: PATH_NAME_WAITING_SERVICE,
    components: {
      waiting: () => import(/* webpackChunkName: "waiting" */'@/pages/wating_service')
    }
  },
  {
    path: '/wavvie_popup',
    name: PATH_NAME_WAVVIE_POPUP,
    components: {
      wavvie_popup: () => import('@/components/common/WavviePopup')
    }
  },
  {
    path: '/event/index',
    name: PATH_NAME_EVENT_EMERGENCY,
    alias: '/event/index.html',
    components: {
      event_emergency: () => import('@/pages/event/index')
    }
  },
  {
    path: '/signup',
    name: PATH_NAME_SIGNUP_REDIRECT,
    redirect: (to) => {
      if (cookie.hasItem('signup-credential')) {
        const autoLogin = autoLoginProc()
          autoLogin.then(() => {
            const referer = _.get(to, 'query.referer', '')
            if (referer !== null && referer !== '' && referer !== undefined) {
              let res = referer.replace('http://', '')
              res = res.replace('https://', '')
              res = res.replace('www.wavve.com', '')
              res = res.replace('m.wavve.com', '')
              res = res.replace('localhost', '')
              location.href = res
            } else {
              return { name: PATH_NAME_HOME }
            }
          })
      } else {
        return { name: PATH_NAME_HOME }
      }
    }
  },
  // for test
  {
    path: '/player/test',
    name: PATH_NAME_PLAYER_TEST,
    components: {
      mainLayout: () => import('@/components/PlayerTest.vue')
    }
  }
]
